import { TimeRange } from 'components/DataEntry/Button/types';

export const reportChartTimeRangeOptions = [
  TimeRange.W1,
  TimeRange.M1,
  TimeRange.M3,
  TimeRange.M12,
].map(o => ({ label: o, value: o }));
